(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-mm-cookie-preferences]');
    if (!link) return;
    const banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') return;
    event.preventDefault();
    const fallback = function () { window.location.assign(link.href); };
    try {
      Promise.resolve(banner.showPreferences()).catch(fallback);
    } catch (error) {
      fallback();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
